import styled, { StyledProps } from 'styled-components'

import { EModSize, IModSize } from '@ucheba/utils/helpers/styles/mod.types'
import { sm } from '@ucheba/utils/helpers/styles/mixins'

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const NoPhoto = styled.div<StyledProps<IModSize>>`
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    ${sm.mod(EModSize.usmall)`
      width: 24px;
      height: 24px;
  `};

    ${sm.mod(EModSize.xxsmall)`
    width: 32px;
    height: 32px;
    `};

    ${sm.mod(EModSize.small)`
    width: 48px;
    height: 48px;
  `};

    ${sm.mod(EModSize.large)`
    width: 64px;
    height: 64px;
  `};

    ${sm.mod(EModSize.uxlarge)`
    width: 96px;
    height: 96px;
  `}
  }
`

const Block = styled.div<StyledProps<IModSize>>`
  position: relative;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;

  ${sm.mod(EModSize.usmall)`
      width: 24px;
      height: 24px;
  `};

  ${sm.mod(EModSize.xxsmall)`
    width: 32px;
    height: 32px;
    `};

  ${sm.mod(EModSize.small)`
    width: 48px;
    height: 48px;
  `};

  ${sm.mod(EModSize.large)`
    width: 64px;
    height: 64px;
  `};

  ${sm.mod(EModSize.uxlarge)`
    width: 96px;
    height: 96px;
  `}
`

export { Block, NoPhoto, Image }
